<template>
  <div>
    <div class="submenu">
      <div class="action">
        <img src="@/assets/SearchIcon.svg" alt="search panel icon"
             data-cy="search-button"
             @click="showHidePanel('SEARCH')"
             class="search-icon hover-scale"
        />
        <div class="notif-image">
          <img src="@/assets/NotificationIcon.svg" alt="search panel icon"
               data-cy="notifications-button"
               @click="showHidePanel('NOTIF')"
               class="notif-icon hover-scale"
          />
          <div data-cy="notification-indication" class="bubble-number notif-number">
            {{ notificationsNumber }}
          </div>
        </div>
        <current-user-photo data-cy="avatar-button" class="avatar" />
      </div>
      <Konami />
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import CurrentUserPhoto from '../shared/CurrentUserPhoto'
import { mapState } from 'vuex'
import Konami from '../shared/Konami'

export default {
  name: 'SubMenu',
  components: { CurrentUserPhoto, Konami },
  directives: {
    ClickOutside
  },
  data() {
    return {
      isExpanded: localStorage.getItem('isExpanded') === 'true'

    }
  },
  methods: {
    goToHome() {
      this.$router.push({ name: 'homePage' }).catch(_ => {})
    },
    goToAdministrator() {
      this.$router.push({ name: 'administratorPage' }).catch(_ => {})
    },
    goToDashboard() {
      this.$router.push({ name: 'dashboardPage' }).catch(_ => {})
    },
    goToCommunities() {
      this.$router.push({ name: 'communitiesPage' }).catch(_ => {})
    },
    showHidePanel(panelType) {
      this.$store.dispatch('showHidePanel', panelType)
      if (panelType === 'NOTIF') {
        this.$store.dispatch('seeNewNotifications')
      }
    },
    notifNumber(count) {
      if (count === 0) {
        return
      } else if (count > 99) {
        return '99+'
      }
      return count
    }
  },
  computed: {
    isAdministrator() {
      return this.$store.getters.auth.isAdmin
    },
    notificationsNumber() {
      return this.notifNumber(this.newNotificationsNumber)
    },
    reportedContentNumber() {
      return this.notifNumber(this.reportedContentCount)
    },
    isAdminRoute() {
      return this.$store.getters.isAdminRoute
    },
    ...mapState({
      activeRoute: (state) => state.route.activeRoute,
      newNotificationsNumber: (state) => state.user.user.newNotificationsNumber,
      reportedContentCount: (state) => state.user.reportedContentCount
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="./SubMenu.scss"></style>
